import { useQuery } from '@apollo/client';
import { DEFAULT_TAGS } from '../../cashflow';
import { TransactionEntryTagsDocument } from '../../graphql/generated';
import { sortBy } from '../../util/arrays';
import { TransactionEntryTag } from './types';

export const useTags = (
    options: { includeDefaults?: boolean } = { includeDefaults: true }
): {
    loading: boolean;
    tags: TransactionEntryTag[];
} => {
    const { data, loading } = useQuery(TransactionEntryTagsDocument);

    let tags: TransactionEntryTag[] = data?.transactionEntryTags ?? [];

    if (options.includeDefaults) {
        // Combine tags with DEFAULT_TAGS - only include DEFAULT_TAGS that are not already in tags
        DEFAULT_TAGS.forEach((defaultTag) => {
            if (!tags.some((tag) => tag.name === defaultTag.name)) {
                tags = [...tags, defaultTag];
            }
        });
    }

    const sortedTags = sortBy(tags, (tag) => {
        const defaultTagIndex = DEFAULT_TAGS.findIndex(
            (defaultTag) => defaultTag.name === tag.name
        );

        // Show default tags first, then custom tags sorted alphabetically
        return defaultTagIndex === -1
            ? `${DEFAULT_TAGS.length + 1}${tag.name}`
            : defaultTagIndex.toString();
    });

    return { tags: sortedTags, loading };
};
